export default {
  computed: {
    //THIS ARRAY PRPOP IS USED DIRECTLY IN TEMPLATE
    filteredSites() {
      if (!!this.projectId) {
        return this.sites.filter(site => {
          return site.projectId == this.projectId
        })
      } else {
        return this.sites;
      }
    },
    siteObj() {
      return this.sites.filter(site => {
        return site.id == this.siteId
      })[0]
    }
  },
  watch: {
    siteId(val) {
      if (!!val) {
        //console.log(this.siteObj);
        this.projectId = this.siteObj.projectId
      }
    },
    projectId(val) {
      if (!!val && !!this.siteId) {
        if (this.siteObj.projectId != val) {
          this.siteId = null
        }
      }
    }
  },
}